import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  Data,
  NavigationBehaviorOptions,
  NavigationExtras,
  Params,
  Router,
  UrlTree,
} from '@angular/router';

import { getSelectors } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

export const {
  selectCurrentRoute,
  selectFragment,
  selectQueryParam,
  selectQueryParams,
  selectRouteData,
  selectRouteParam,
  selectRouteParams,
  selectUrl,
} = getSelectors();

@Injectable({
  providedIn: 'root',
})
export class RouterService {
  constructor(private _store: Store, private readonly _router: Router) {
    this.currentRoute$ = _store.select(selectCurrentRoute);
    this.fragment$ = _store.select(selectFragment);
    this.queryParams$ = _store.select(selectQueryParams);
    this.data$ = _store.select(selectRouteData);
    this.routeParams$ = _store.select(selectRouteParams);
    this.url$ = _store.select(selectUrl);
  }

  public currentRoute$: Observable<ActivatedRoute>;
  public fragment$: Observable<string | undefined>;
  public queryParams$: Observable<Params>;
  public data$: Observable<Data>;
  public routeParams$: Observable<Params>;
  public url$: Observable<string>;

  navigate(paths: string[], extra?: NavigationExtras): Promise<boolean> {
    return this._router.navigate(paths, extra);
  }

  navigateByUrl(url: string | UrlTree, extras?: NavigationBehaviorOptions): Promise<boolean> {
    return this._router.navigateByUrl(url, extras);
  }

  selectQueryParam(param: string): Observable<string | undefined> {
    return this._store.select(selectQueryParam(param));
  }

  selectRouteParam(param: string): Observable<string | undefined> {
    return this._store.select(selectRouteParam(param));
  }
}
